// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"377c8eb9","484":"38134a3b","787":"b312d54f"}[chunkId] + ".chunk.js";
};